/* Copyright (c) 2018-2025, NVIDIA CORPORATION.  All rights reserved.
 *
 * NVIDIA CORPORATION and its licensors retain all intellectual property
 * and proprietary rights in and to this software, related documentation
 * and any modifications thereto.  Any use, reproduction, disclosure or
 * distribution of this software and related documentation without an express
 * license agreement from NVIDIA CORPORATION is strictly prohibited.
 */

import { Injectable } from '@angular/core';
import { RetryConfig } from 'nv-angular-http-endpoint/lib/nv-http-endpoint/nv-http-endpoint';
import { StorageType } from './constants/constants';
import { PlatformType } from './enums/platform-type.enum';

@Injectable()
export class StarfleetConfig {
    platformType: PlatformType;
    url: string;
    offDeviceShortUrl?: string;
    logoutUrl: string;
    keyValueServiceUrl: string;
    clientId: string;
    scope: string;
    deviceId: string;
    redirectUrl: string;
    portNumbers: number[];
    onCompleteRedirectUrl: string;
    redirectParams: string[];
    sdkClient: string;
    redirectUrlIsRelative?: boolean;
    useNativeAuthCommands?: boolean;
    httpServerDuration: number;
    clientTokenRefreshDuration: number;
    clientTokenRefreshDurationInPercentage: number;
    useDeviceAuthLogin?: boolean;
    skipOpeningLogoutUrl?: boolean;
    useAuthorizationCodeFlow?: boolean;
    sameTabLogin?: boolean;
    idTokenRefreshUnderDuration?: number;
    addLogintracer?: boolean;
    ssoSharedPageUrl?: string;
    ssoEnabled?: boolean;
    maxWaitTimeSSO?: number;
    maxWaitTimeIframeLoad?: number;
    jarvisIdpId?: string;
    offDeviceUiUrl?: string;
    hideSystemName?: boolean;
    useNvAccountForUserConsent?: boolean;
    storageType?: StorageType;
    retryConfig?: RetryConfig;
    inAppBrowserBrowserLogin?: boolean;
}
